import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Local /media MP4s also ship a WebM twin for maximum browser coverage.
export const videoSources = (url) =>
  url && url.startsWith("/media/") && url.endsWith(".mp4")
    ? [
        { src: url, type: "video/mp4" },
        { src: url.replace(/\.mp4$/, ".webm"), type: "video/webm" },
      ]
    : [{ src: url, type: "video/mp4" }];

export default function VideoPlayerModal({ src, title, poster, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

  return createPortal(
    <div
      className="fixed inset-0 z-[80] bg-[#050B1E]/95 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={(e) => { stop(e); onClose(); }}
      data-testid="product-video-modal"
    >
      <div className="w-full max-w-4xl" onClick={stop}>
        <div className="flex items-center justify-between mb-3">
          <div className="text-white font-display font-bold text-sm sm:text-base truncate pr-4">{title}</div>
          <button
            onClick={(e) => { stop(e); onClose(); }}
            className="shrink-0 bg-white/10 hover:bg-[#F0B90B] hover:text-[#0A1E5E] text-white rounded-full p-2.5 transition-colors"
            data-testid="video-modal-close"
            aria-label="Close video"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="rounded-lg overflow-hidden border-2 border-[#F0B90B]/50 shadow-[0_0_45px_rgba(240,185,11,0.25)] bg-black">
          <video
            poster={poster || undefined}
            controls
            autoPlay
            playsInline
            className="w-full max-h-[75vh] bg-black"
            data-testid="video-modal-player"
          >
            {videoSources(src).map((s) => (
              <source key={s.src} src={s.src} type={s.type} />
            ))}
          </video>
        </div>
      </div>
    </div>,
    document.body
  );
}
